// Equipment rows that are not yet in the database (equipmentType === "new") need an id that is
// unique for as long as the screen is open: every edit, revert and selection in EquipmentsTable
// matches rows by id, so two rows sharing one edit each other (ADO #248). Save paths discard
// these ids — new rows are inserted, never updated by id — so they only have to be unique here.
// Rows loaded from the database keep their real id, which the update path depends on.
let lastKey = 0;

export const newEquipmentRowKey = () => {
  lastKey += 1;
  return `new-${lastKey}`;
};

export const keyNewEquipmentRows = (rows) =>
  (rows || []).map((row) =>
    row.equipmentType === "new" ? { ...row, id: newEquipmentRowKey() } : row
  );
